import type {
  AnalysisResponse,
  CalendarResponse,
  IndicatorResponse,
  PaginatedResponse,
  ReleaseDetailResponse,
  ReleaseResponse,
  ReleasesFilter,
} from "./types";

const BASE_URL = import.meta.env.VITE_API_URL ?? "";

async function get<T>(path: string, params?: Record<string, string | number | undefined>): Promise<T> {
  const url = new URL(`${BASE_URL}${path}`, window.location.origin);
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== null && v !== "") {
        url.searchParams.set(k, String(v));
      }
    }
  }
  const res = await fetch(url.toString());
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API error ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}

// --- Indicators ---

export const getIndicators = (country?: string, category?: string) =>
  get<IndicatorResponse[]>("/api/v1/indicators", { country, category });

export const getIndicator = (id: string) =>
  get<IndicatorResponse>(`/api/v1/indicators/${id}`);

// --- Releases ---

export const getReleases = (filter: ReleasesFilter = {}) =>
  get<PaginatedResponse<ReleaseResponse>>("/api/v1/releases", {
    indicator_id: filter.indicator_id,
    country: filter.country,
    from_date: filter.from_date,
    to_date: filter.to_date,
    page: filter.page ?? 1,
    size: filter.size ?? 20,
  });

export const getRelease = (id: string) =>
  get<ReleaseDetailResponse>(`/api/v1/releases/${id}`);

// --- Analyses ---

export const getAnalyses = (releaseId: string) =>
  get<AnalysisResponse[]>(`/api/v1/analyses/${releaseId}`);

// --- Calendar ---

export const getCalendar = (week: "current" | "next" = "current", country?: string) =>
  get<CalendarResponse>("/api/v1/calendar", { week, country });
